/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// images
import intro1 from "./imgs/01_enbrain_info.png";
import intro2 from "./imgs/02_enbrain_info.png";
import intro3 from "./imgs/03_enbrain_info.png";

import {
  container,
} from "assets/jss/material-dashboard-pro-react.jsx";

const enbrainIntroPageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    }
  },
  image: {
    width: "100%",
    height: "100%"
  }
})

class EnbrainIntroPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer>
          <GridItem>
            <img src={intro1} className={classes.image} />
          </GridItem>
          <GridItem>
            <img src={intro2} className={classes.image} />
          </GridItem>
          <GridItem>
            <img src={intro3} className={classes.image} />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

EnbrainIntroPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(enbrainIntroPageStyle)(EnbrainIntroPage);
